export default "__VITE_ASSET__Thoeyg5OGzt$0m9bghM22A__"